
export const RETURN_TO_HOME = "RETURN_TO_HOME";

export function returnToHome() {
    return {
        type: RETURN_TO_HOME,
        payload: null
    };
}


/** WEBPACK FOOTER **
 ** ./src/main/javascript/compliance/complianceActions.js
 **/